export const FILTER_DAYS = [
  {
    id: 'Segunda-Feira',
    slug: 'Segunda-Feira',
    name: 'Segunda-Feira',
  },
  {
    id: 'Terca-Feira',
    slug: 'Terca-Feira',
    name: 'Terça-Feira',
  },
  {
    id: 'Quarta-Feira',
    slug: 'Quarta-Feira',
    name: 'Quarta-Feira',
  },
  {
    id: 'Quinta-Feira',
    slug: 'Quinta-Feira',
    name: 'Quinta-Feira',
  },
  {
    id: 'Sexta-Feira',
    slug: 'Sexta-Feira',
    name: 'Sexta-Feira',
  },
  {
    id: 'Sábado',
    slug: 'Sabado',
    name: 'Sábado',
  },
]
